const TATA_BASE = "https://api-smartflo.tatateleservices.com";

const STORAGE_TOKEN_KEY = "tata_sf_token";
const STORAGE_EXPIRY_KEY = "tata_sf_expiry";

// Token lifetime: Tata tokens last 60 min; we refresh 5 min early
const TOKEN_TTL_MS = 55 * 60 * 1000;

// ── Persist helpers ─────────────────────────────────────────────────────────

const saveToStorage = (token, expiry) => {
  localStorage.setItem(STORAGE_TOKEN_KEY, token);
  localStorage.setItem(STORAGE_EXPIRY_KEY, String(expiry));
};

const clearStorage = () => {
  localStorage.removeItem(STORAGE_TOKEN_KEY);
  localStorage.removeItem(STORAGE_EXPIRY_KEY);
};

export const getStoredTataToken = () => {
  const token = localStorage.getItem(STORAGE_TOKEN_KEY);
  const expiry = Number(localStorage.getItem(STORAGE_EXPIRY_KEY));
  if (token && expiry && Date.now() < expiry) return { token, expiry };
  return null;
};

// ── Auth API calls ──────────────────────────────────────────────────────────
// Credentials come from the agent's user profile (tataSmartFlowId + tataSmartFlowPassword)

export const tataLogin = async (tataSmartFlowId, tataSmartFlowPassword) => {
  const res = await fetch(`${TATA_BASE}/v1/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ email: tataSmartFlowId, password: tataSmartFlowPassword }),
  });
  const data = await res.json();
  console.log("[Tata] login response:", data);
  if (!res.ok || !data?.access_token)
    throw new Error(data?.message || "Tata SmartFlo login failed");

  const expiry = Date.now() + TOKEN_TTL_MS;
  saveToStorage(data.access_token, expiry);
  return { token: data.access_token, expiry };
};

export const tataRefresh = async (currentToken) => {
  const res = await fetch(`${TATA_BASE}/v1/auth/refresh`, {
    method: "POST",
    headers: { Accept: "application/json", Authorization: currentToken },
  });
  const data = await res.json();
  console.log("[Tata] refresh response:", data);
  if (!res.ok || !data?.access_token)
    throw new Error(data?.message || "Tata SmartFlo token refresh failed");

  const expiry = Date.now() + TOKEN_TTL_MS;
  saveToStorage(data.access_token, expiry);
  return { token: data.access_token, expiry };
};

export const tataLogout = async (currentToken) => {
  try {
    await fetch(`${TATA_BASE}/v1/auth/logout`, {
      method: "POST",
      headers: { Accept: "application/json", Authorization: currentToken },
    });
    console.log("[Tata] logged out");
  } catch (err) {
    console.warn("[Tata] logout error (ignored):", err);
  }
  clearStorage();
};
